//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)

import store from "@/assets/js/store.js";
import mslogin from '@/assets/js/msLogin.js';
import bind_modal from '@/components/AreaBind';

//引用页面
import select from '@/views/select.vue';
import shop from '@/views/shop.vue';
import score from '@/views/score.vue';


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

//定义routes路由的集合，数组类型
const routes = [
    //单个路由均为对象类型，path代表的是路径，component代表组件
    {path:'/index',name :'index',component: select, meta: { isAuth:false, isZid : false,},},
    {path:"/score",name :'score',component: score, meta: { isAuth:false, isZid : false,},},
    {path:"/shop",component:shop, meta: { isAuth:true, isZid : false,},},
    {path:"/shop",component:shop, meta: { isAuth:true, isZid : false,},},
    //写个路径为空的路由
    {path:"",redirect: '/index'}    
]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
//ES6简写，等于routes：routes
    routes,
});

//全局前置路由守卫-- 初始化的时候被调用,每次路由切换之前被调用
router.beforeEach((to, from, next) => {
    //var userObj = JSON.parse(localStorage.getItem("userObj"));
    //判断是否进行校验
    // if (to.meta.isAuth) {
    //   if (store.state.login) {
    //     if(store.state.userinfo.zid){
    //       next();
    //     }
    //     else{
    //       next("/");
    //       bind_modal();
    //     }

    //   } else {
    //     next("/");
    //     mslogin.open();
    //   }
    // } else {
    //   next();
    // }
    next();
});

router.afterEach(() => {
    const vcTooltipDom = document.getElementById('vc-tooltip')
    vcTooltipDom && document.body.removeChild(vcTooltipDom)
});

//抛出这个这个实例对象方便外部读取以及访问
export default router
